<div _ngcontent-ng-c1362099036="" class="sidebar">
<nav _ngcontent-ng-c1362099036="" class="sidebar-nav ps ps--active-y apply-scroll" style="width: 99.8%">
<div _ngcontent-ng-c1362099036="" class="top-head-sport">
<ul _ngcontent-ng-c1362099036="" class="text-right mr-2">
<li _ngcontent-ng-c1362099036="">
<a _ngcontent-ng-c1362099036="" class="path-back"><i _ngcontent-ng-c1362099036="" aria-hidden="true" class="fa fa-ellipsis-v" style="font-size: 14px"></i></a>
</li>
<li _ngcontent-ng-c1362099036="">
<a _ngcontent-ng-c1362099036="" style="position: relative; top: 1.5px">Sports</a>
</li>
</ul>
</div>
<div _ngcontent-ng-c1362099036="" class="scrollNav">
<ul _ngcontent-ng-c1362099036="" class="nav">
<!-- -->
<div _ngcontent-ng-c1362099036="" class="sideW ng-star-inserted">
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/4" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Cricket</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/livecasino/1" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Casino</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/2" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Tennis</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/1" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Soccer</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/7" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Horse Racing</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/10" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Politics</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/4339" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Greyhound Racing</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/7522" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Basketball</span></a>
</li>
<li _ngcontent-ng-c1362099036="" class="nav-item nav-dropdown ng-star-inserted">
<a _ngcontent-ng-c1362099036="" class="nav-link nav-dropdown-toggle" routerLink="/allsport-highlight/9" routerLinkActive="active"><span _ngcontent-ng-c1362099036="">Lottery</span></a>
</li>
<!-- -->
</div>
<!-- -->
</ul>
</div>
<div _ngcontent-ng-c1362099036="" class="ps__rail-y" style="top: 0px; height: 403px; right: 0px">
<div _ngcontent-ng-c1362099036="" class="ps__thumb-y" style="top: 0px; height: 379px" tabindex="0"></div>
</div>
</nav></div>